import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route } from 'react-router-dom';
import { renderLazyWidgetFromConfig } from '@/widgets/widgetFactory';
import { useConfig } from './hooks/useConfig';
import Layout from './components/layout/Layout';
export const AppRouter = () => {
    const { config } = useConfig();
    if (!config)
        return null;
    const routes = config.application.routing?.routes ?? [];
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Layout, {}), children: routes.map(route => (_jsx(Route, { path: route.path, element: renderLazyWidgetFromConfig(route.widget) }, route.path))) }), _jsx(Route, { path: "*", element: _jsx("div", { children: "Page not found" }) })] }));
};
